export const getIsAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};